export default function ({ store, error }) {
  if (!store.state.auth.user || (store.state.auth.user && store.state.auth.user.role !== 1)) {
    return error({ statusCode: 403, message: 'Доступ запрещен' })
  }
}
